module.exports = __webpack_public_path__ + "static/media/icono_clabe.7a178de1.svg";